import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { IReduxState, IStepState, StepCounterType } from '../types/state';
import { SingleColorType } from '../types/colors';
import { IChoiceStep } from '../types/steps';

import { setBackgroundColor } from '../redux/actions/backgroundColor';
import { nextStep, previousStep } from '../redux/actions/step';

import { AppHeader } from '../components/AppHeader';
import { colors } from '../constants';

interface IProps {
    stepCounterName: StepCounterType;
    testDisplayName: string;
    steps: IChoiceStep[];
    stepState: IStepState;
    stepDisplayNumber: number;
    totalSteps: number;
    setBackgroundColorConnect(color: SingleColorType): void;
    onNextStep(counter: StepCounterType): void;
    onPreviousStep(counter: StepCounterType): void;
    onCloseButtonClick?(): void;
}

const BaseGenericChoiceTest: React.FC<IProps> = ({
    stepCounterName,
    testDisplayName,
    steps,
    stepState,
    stepDisplayNumber,
    totalSteps,
    setBackgroundColorConnect,
    onNextStep,
    onPreviousStep,
    onCloseButtonClick,
}) => {
    const subStep = stepState[stepCounterName];
    const currentStep = steps[subStep - 1];

    useEffect(() => {
        setBackgroundColorConnect(currentStep.bgColor);
    }, [subStep]);

    const handleAnimationExit = () => {
        if (subStep < steps.length) {
            return onNextStep(stepCounterName);
        }

        return onNextStep('main');
    };

    const handleBackButtonClick = () => {
        if (subStep === 1) {
            return onPreviousStep('main');
        }

        return onPreviousStep(stepCounterName);
    };

    const headerGrey =
        !currentStep.bgColor || currentStep.bgColor === colors.white;

    return (
        <>
            <AppHeader
                totalSteps={totalSteps}
                stepNumber={stepDisplayNumber}
                greyTheme={headerGrey}
                onBackButtonClick={handleBackButtonClick}
                onCloseButtonClick={onCloseButtonClick}
            />
            <currentStep.component
                key={subStep}
                {...currentStep.props}
                stepDisplayNumber={stepDisplayNumber}
                testDisplayName={testDisplayName}
                onAnimationExit={handleAnimationExit}
            />
        </>
    );
};

const mapStateToProps = (state: IReduxState) => ({
    stepState: state.step,
});

const mapDispatchToProps = {
    setBackgroundColorConnect: setBackgroundColor,
    onNextStep: nextStep,
    onPreviousStep: previousStep,
};

export const GenericChoiceTest = connect(
    mapStateToProps,
    mapDispatchToProps
)(BaseGenericChoiceTest);
